module.exports = __webpack_public_path__ + "static/media/profile.e947f1ec.jpg";